export enum ServiceAreasServiceType {
  Planning = "Planning",
  Pricing = "Pricing"
}
